/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PepsiCo Geospatial UAV API
 * OpenAPI spec version: 0.1.0
 */

export type Sector = (typeof Sector)[keyof typeof Sector];

export const Sector = {
  APAC: "APAC",
  LATAM: "LATAM",
  PFNA: "PFNA",
  AMESA: "AMESA",
  EU: "EU",
} as const;
